// React
import React, { useState, useContext, useEffect } from 'react';

// Global Context
import { GlobalContext } from '../../../contexts/Global';

// Kendo
import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Form, Field, FormElement, FieldWrapper } from "@progress/kendo-react-form";
import { Input, TextArea } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";

// Leaflet
import { MapContainer, TileLayer, Polygon } from 'react-leaflet';

// Components
import Title from '../../../components/Page/Title';
import StaticText from '../../../components/Forms/StaticText/StaticText';
import { default as YaardField } from '../../../components/Page/Field';
import Success from '../../../components/Page/Success';
import Loader from '../../../components/Loader/Loader';

// Styles

const MainCersPage = () => {
    const { user } = useContext(GlobalContext);
    const [ cers, setCers ] = useState(null);
    const [ response, setResponse ] = useState(null);
    const [ isLoading, showLoader ] = useState(false);

    useEffect(()=> {
        showLoader(true);
        fetch(process.env.REACT_APP_API_BASE_URL + "/admin/cers/1", {
            headers: {
                Authorization: 'Bearer ' + user.access_token
            }
        })
            .then((response) => response.json())
            .then((response) => {
                showLoader(false);
                setCers(response.data.cers);
            });
    }, [ ])

    const updateCers = (data) => {
        let payload = { ...data };

        showLoader(true);

        fetch(process.env.REACT_APP_API_BASE_URL + '/admin/cers/1', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + user.access_token
            },
            body: JSON.stringify(payload)
        })
        .then((response) => response.json())
        .then((response) => {
            showLoader(false);
            setResponse(response);
        })
        .catch((err) => {
        });
    }

    return (
        <>
            <Title>Comunità energetica lodigiana</Title>
            <div className="section grid-template-two-columns">
                <div className="left">
                    { cers &&
                        <Form
                            initialValues={ cers }
                            onSubmit={ updateCers }
                            render={(formRenderProps) => (
                                <FormElement>
                                    <GridLayout cols={[ { width: '1fr' }, { width: '1fr' } ]} gap={{ rows: 20, cols: 20 }}>
                                        <GridLayoutItem row={ 1 } col={ 1 } colSpan={ 2 }>
                                            <fieldset className="k-form-fieldset">
                                                <FieldWrapper>
                                                    <Label className="k-form-label">Nome</Label>
                                                    <div className="k-form-field-wrap">
                                                        <Field name="name" component={ StaticText } />
                                                    </div>
                                                </FieldWrapper>
                                            </fieldset>
                                        </GridLayoutItem>

                                        <GridLayoutItem row={ 2 } col={ 1 } colSpan={ 2 }>
                                            <fieldset className="k-form-fieldset">
                                                <FieldWrapper>
                                                    <Label className="k-form-label">Descrizione</Label>
                                                    <div className="k-form-field-wrap">
                                                        <Field name="description" autoSize={ true } component={ TextArea } />
                                                    </div>
                                                </FieldWrapper>
                                            </fieldset>
                                        </GridLayoutItem>

                                        <GridLayoutItem colSpan={ 2 }>
                                            <div className="k-form-buttons k-justify-content-between k-flex-wrap">
                                                <Button type="submit" rounded={ null } size="large" themeColor="primary" disabled={ !formRenderProps.modified }>SALVA</Button>
                                            </div>
                                        </GridLayoutItem>

                                    </GridLayout>
                                </FormElement>
                            )}
                        />
                    }
                </div>

                <div className="right">
                    <YaardField label="Mappa" className="k-h-full k-d-flex k-flex-col">
                        <MapContainer center={[ 45.3140617, 9.4998361 ]} zoom={ 15 } scrollWheelZoom={ true } zoomControl={ false }>
                            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                        </MapContainer>
                    </YaardField>
                </div>
            </div>

            <Success enter={ response } exit={ setResponse } />

            { isLoading && (<Loader />) }
        </>
    );
}

export default MainCersPage;
